import PropTypes from "prop-types";
import { Placeholder as BSPlaceholder } from "react-bootstrap";

import { PlaceholderContainer } from "./Placeholder.styles";

export const Placeholder = ({
  size,
  bg,
  children,
  as = "div",
  col = { xs: 12 },
  isLoading = true,
  animation = "glow",
  ...props
}) =>
  isLoading ? (
    <PlaceholderContainer
      className="placeholder-glow"
      bg={bg}
      as={as}
      animation={animation}
    >
      <BSPlaceholder {...col} size={size} {...props} />
    </PlaceholderContainer>
  ) : (
    <>{children}</>
  );

Placeholder.propTypes = {
  as: PropTypes.any,
  col: PropTypes.any,
  bg: PropTypes.string,
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  size: PropTypes.string,
  animation: PropTypes.string,
};
